<template>
  <panel>
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped w-100 dataTable dtr-inline">
        <thead>
          <tr role="row">
            <th width="150px">
              Data
            </th>

            <th width="150px">
              Akcja
            </th>

            <th width="150px">
              Użytkownik
            </th>

            <th>Zmiany</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="log in history" :key="`history_${log.id}`">
            <td class="text-nowrap">
              <tooltip :text="dateTime(log.created)">
                <span>{{ log.created | moment('DD.MM.YYYY HH:mm') }}</span>
              </tooltip>
            </td>

            <td>{{ log | historyAction }}</td>

            <td>{{ log | translateProfile }}</td>

            <td>
              <p v-if="historyChanges(log)" class="p--newline" v-html="historyChanges(log)" />

              <p v-if="log.comment">{{ log.comment }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import Tooltip from '@/components/tooltip/Tooltip';
import { dateTime } from '@/filters/date';
import { historyAction } from '@/filters/historyAction';
import { historyChanges } from '@/filters/historyChanges';
import { tableName } from '@/filters/tableName';
import { AUTOSAVE } from '@/utils/constants';

// @vuese
// Historia dokumentu
// @group Document
export default {
  components: { Panel, Tooltip },
  filters: {
    historyAction,
    tableName,
    translateProfile(log) {
      if (log.profile) {
        return (log.profile.firstName || '') + ' ' + (log.profile.lastName || '');
      } else {
        return 'Nieznany użytkownik';
      }
    }
  },
  computed: mapState({ history: state => state.history.list.filter(log => log.comment !== AUTOSAVE) }),
  methods: { historyChanges, dateTime }
};
</script>

<style>
.checksum {
  font-family: Consolas;
}
</style>
